var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-speech-recognition",class:{
  'active': _vm.isRecognizing
},on:{"click":_vm.start}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }